import { Props_SnippetImageContent } from './ImageContent.props'
import { CompileHeadingToSpan, CompileMarkdown } from '../../../../Shared/AttraxTs/React/ReactSnippetMDCompiler'
import SnippetLink from '../Shared/Link/Link'


const classAssignment = (prop: string | undefined | boolean, positiveClassName: string, negativeClassName = '') => {
    if (prop) {
        if (typeof prop === 'string') {
            return `${positiveClassName}--${prop}`
        }
        if (typeof prop === 'boolean') {
            return positiveClassName
        }
    }
    return negativeClassName
}


const SnippetImageContent = (props: Props_SnippetImageContent) => {
    const { snippet, heading, image, content, repeatable_link, link } = props

    const classHeadingVisibility = classAssignment(heading.visibility?.value, 'snippet-image-content__heading--visible', 'snippet-image-content__heading--hidden')
    const classSnippetLayout = classAssignment(snippet.layout?.value, 'snippet-image-content')
    const classLinkAlignment = classAssignment(link.alignment?.value, 'snippet-image-content__button-container')
    const backgroundColorClass = classAssignment(snippet.backgroundColor?.value, 'snippet-image-content--bg')
    const fontColorClass = classAssignment(snippet.fontColor?.value, 'snippet-image-content--font')
    const accentColorClass = classAssignment(snippet.accentColor?.value, 'snippet-image-content--accent')

    const modifierclasses = `${classSnippetLayout} ${backgroundColorClass} ${fontColorClass} ${accentColorClass}`

    return (
        <section className={`snippet-image-content ${modifierclasses}`}>
            <div className="snippet-image-content__container">
                <div className="snippet-image-content__container-image">
                    <img
                        loading="lazy"
                        src={image.src.value}
                        className="snippet-image-content__image"
                        height="360"
                        width="600"
                        alt={image.alt?.value || ''}
                    />
                </div>
                <div className="snippet-image-content__container-content">
                    <h2 className={`snippet-image-content__heading ${classHeadingVisibility}`}>{CompileHeadingToSpan(heading.content.value!)}</h2>
                   {content.content?.value && <div className="snippet-image-content__content">
                        {CompileMarkdown(content.content.value)}
                    </div>}

                    <div className={`snippet-image-content__button-container ${classLinkAlignment}`}>
                        {repeatable_link.map(({ linkHref, linkStyle, linkTarget, linkText }, index) => (
                            <div key={index + (linkHref?.value || '')} className="snippet-image-content__link">
                                <SnippetLink
                                    linkStyles={linkStyle?.value}
                                    className="snippet-image-content__link"
                                    url={linkHref?.value}
                                    openInNewTab={linkTarget?.value}
                                >
                                    {linkText?.value}
                                </SnippetLink>
                            </div>
                        ))}
                    </div>

                </div>
            </div>
        </section>
    )
}

export default SnippetImageContent